/**************************************************
 * Nombre:       Tarjetas_Comentarios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import dayjs from "dayjs";


const Tarjetas_Comentarios = ({item, index, click}) => {
    dayjs.locale("es");


    return (
        <Grid
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2, mt: 2, pb: 2}}
            spacing={0}
        >


            <Grid container size={2}>
                <Avatar src={item.img}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 10}}>


                <Grid container size={12}>
                    <Typography
                        sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 12}}>{`${item.usuario}`}</Typography>
                </Grid>

                <Grid container size={12} sx={{mt: 0.5}}>
                    <Typography
                        sx={{fontWeight: 300, lineHeight: 1.1, fontSize: 14}}>{`${item.comentario}`}</Typography>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjetas_Comentarios